<template>
  <v-layout row>
    <div v-if="!this.$isEmpty(value.identifierValue) || !this.$isEmpty(value.coverId)" class="inlinebox">
      <span class="smalltext greytext">Results for&nbsp;</span>
      <span class="smalltext greytext" v-if="!this.$isEmpty(value.identifierValue)">Buyer with {{ value.identifierTypeCode }} {{ value.identifierValue }}</span>
      <span class="smalltext greytext" v-if="!this.$isEmpty(value.identifierValue) && !this.$isEmpty(value.coverId)">&nbsp;and&nbsp;</span>
      <span class="smalltext greytext" v-if="!this.$isEmpty(value.coverId)">Cover Id {{ value.coverId.toLowerCase() }}</span>
    </div>
  </v-layout>
</template>
<script>
export default {
  props: ['value']
}
</script>
